var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path31, _path32, _path33, _path34, _path35, _rect34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallTown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30vh",
    viewBox: "0 0 998.5 479.0163",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.50272,476.51826l3.40229-63.28253s111.595-23.13555,111.595-89.82036-182.36256-74.8503-200.7349-44.22972c-.18372,.30621-.36632,.61236-.54781,.91842-22.69259,38.27041-9.88063,87.95544,28.7344,110.0565,13.20425,7.55736,28.94762,14.02434,47.34416,17.63151l-1.29586,67.22619",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 68.01826,
    r: 63,
    fill: "#ff6884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M687.05838,461.5172l-71.05322-4.5293-3.83154-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301l76.12061-76.12061c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61426l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M698.99979,114.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M654.99979,229.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h30.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-30.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M724.65652,358.23692c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M630.16629,356.25157c-1.39697-1.34863-2.1665-3.16113-2.1665-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26514-6.85254l1.55811-.41602c2.18799-.58008,4.45752-.11133,6.23047,1.29297,1.77344,1.4043,2.75244,3.50684,2.68652,5.76855l-1.55859,52.98145c-.10986,3.72559-3.11328,6.74805-6.83838,6.87988-.08643,.00293-.17236,.00391-.2583,.00391-1.84521,0-3.5835-.70117-4.91846-1.98926Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M659.99979,350.92638v-54.97461c0-3.88086,3.03955-6.99512,6.91943-7.09082l28.0083-.68262c3.88232-.05371,7.14893,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08643,2.15039h-29.62207c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M825.54754,388.49167l21.95246,39.02659,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59272-3.08906,12.39721,.04755,17.97341Z",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 778.07289,
    y: 459.33346,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-6.21016 11.16674) rotate(-.78329)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 777.44411,
    y: 450.28467,
    width: 67.55678,
    height: 1.00003,
    transform: "translate(-3.49689 6.35124) rotate(-.44761)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 776.87388,
    y: 441.63322,
    width: 64.63181,
    height: 1.00019,
    transform: "translate(-8.47947 15.88578) rotate(-1.11892)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 777.42757,
    y: 433.06322,
    width: 62.08987,
    height: 1.00055,
    transform: "translate(-13.94245 27.06782) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 776.86029,
    y: 425.09492,
    width: 59.65899,
    height: 1.00062,
    transform: "translate(-14.45504 28.60544) rotate(-2.01348)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 774.42856,
    y: 417.01857,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 773.06158,
    y: 410.33201,
    width: 56.44001,
    height: 1.00007,
    transform: "translate(-4.75909 9.41758) rotate(-.6714)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 771.79863,
    y: 403.91478,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-12.9803 26.74262) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 770.49522,
    y: 396.51849,
    width: 54.00926,
    height: 1.00015,
    transform: "translate(-6.85458 14.07771) rotate(-1.00705)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 768.78066,
    y: 389.92555,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-11.80713 25.01108) rotate(-1.78991)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 767.24863,
    y: 383.26855,
    width: 51.25244,
    height: 1.00005,
    transform: "translate(-3.70976 7.76085) rotate(-.55951)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M763.49979,362.42638v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M687.05838,461.5172l-58.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,4.62549-10.31152,10.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M767.49979,239.42638v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M778.5,466.51826l-3-44-9-42-2.5-11.5h-.00001c-5.13733-3.49339-12.05536,.39254-11.74512,6.59734l.24513,4.90266,9,42,3,44",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M438.0574,445.5172l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301L447.77811,24.53331c10.65527-10.65625,27.42676-11.42432,39.0127-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61426l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00781-11.53809Z",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M449.99979,98.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M405.99979,213.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M470.56717,277.39122c-1.52344,1.20605-2.36426,3.0127-2.30664,4.95508l1.55762,52.98145c.09473,3.2002,2.6748,5.7959,5.87402,5.90918,1.68164,.06738,3.24707-.54687,4.44629-1.70508,1.2002-1.1582,1.86133-2.71484,1.86133-4.38281v-52.56641c0-2.75586-1.85937-5.17578-4.52246-5.88574l-1.55859-.41602c-.52734-.14063-1.06055-.20996-1.58887-.20996-1.35156,0-2.66699,.45312-3.7627,1.32031Z",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.1658,340.25157c-1.39648-1.34863-2.16602-3.16113-2.16602-5.10254v-52.56641c0-3.20801,2.16504-6.02539,5.26465-6.85254l1.55859-.41602c2.18359-.58008,4.45703-.11133,6.23047,1.29297,1.77441,1.40527,2.75293,3.50781,2.68652,5.76855l-1.55859,52.98145c-.10938,3.72559-3.1123,6.74805-6.83789,6.87988-.08594,.00293-.17285,.00391-.25879,.00391-1.84473,0-3.58301-.70117-4.91895-1.98926Z",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M410.99979,334.92638v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c.05957-.00098,.11719-.00195,.17578-.00195,3.81348,0,6.97559,3.05371,7.08691,6.88672l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M576.54754,372.49167l21.95246,39.02659,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59272-3.08906,12.39721,.04755,17.97341Z",
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 529.07289,
    y: 443.33346,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-6.0147 7.76127) rotate(-.78329)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 528.44411,
    y: 434.28467,
    width: 67.55678,
    height: 1.00003,
    transform: "translate(-3.37949 4.4055) rotate(-.44761)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 527.87388,
    y: 425.63322,
    width: 64.63181,
    height: 1.00019,
    transform: "translate(-8.21451 11.02038) rotate(-1.11892)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 528.42757,
    y: 417.06322,
    width: 62.08987,
    height: 1.00055,
    transform: "translate(-13.54864 18.79599) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 527.86029,
    y: 409.09492,
    width: 59.65899,
    height: 1.00062,
    transform: "translate(-14.04662 19.84706) rotate(-2.01348)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 525.42856,
    y: 401.01857,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 524.06158,
    y: 394.33201,
    width: 56.44001,
    height: 1.00007,
    transform: "translate(-4.5887 6.49871) rotate(-.6714)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 522.79863,
    y: 387.91478,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-12.58648 18.47078) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 521.49522,
    y: 380.51849,
    width: 54.00926,
    height: 1.00015,
    transform: "translate(-6.61184 9.69896) rotate(-1.00705)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 519.78066,
    y: 373.92555,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-11.42886 17.22582) rotate(-1.78991)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 518.24863,
    y: 367.26855,
    width: 51.25244,
    height: 1.00005,
    transform: "translate(-3.56539 5.32856) rotate(-.55951)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M514.49979,346.42638v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M438.0574,445.5172l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M518.49979,223.42589v-51.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M529.5,450.51826l-3-44-9-42-2.5-11.5h-.00001c-5.13733-3.49339-12.05536,.39254-11.74512,6.59734l.24513,4.90266,9,42,3,44",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M189.0574,429.5172l-71.05176-4.5293-3.83203-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301L198.77811,8.53331c10.65527-10.65576,27.42773-11.42383,39.01172-1.78662l82.6084,68.71826c6.73926,5.60596,10.54492,13.84863,10.44141,22.61426l-2.83789,240.28076,35.9043,49.86621,.0752,.10547,6.08398,52.72363-181.00781-11.53809Z",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M200.99979,82.92589v-14.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h20.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-20.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#6c63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.99979,197.92589v-54.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h30.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v54.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-30.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.65701,326.23692c-3.72461-.13184-6.72852-3.1543-6.83887-6.87988l-1.55762-52.98145c-.06641-2.26172,.91211-4.36426,2.68555-5.76855s4.04395-1.87402,6.23047-1.29297l1.55859,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.16602,5.10254-1.33594,1.28906-3.07324,1.98926-4.91797,1.98926-.08594,0-.17285-.00098-.25879-.00391Z",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.39366,260.21328l1.55829-.41555c4.26293-1.13678,8.41766,2.15346,8.28796,6.56345l-1.55828,52.98155c-.10216,3.47351-2.88312,6.27124-6.35595,6.39429h-.00001c-3.72997,.13216-6.82567-2.85579-6.82567-6.5881v-52.566c0-2.98662,2.00789-5.60011,4.89366-6.36965Z",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M161.99979,318.92638v-54.97461c0-3.88086,3.03906-6.99512,6.91992-7.09082l28.00781-.68262c3.90234-.0625,7.14941,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08691,2.15039h-29.62109c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M327.54754,356.49167l21.95246,39.02659,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59272-3.08906,12.39721,.04755,17.97341Z",
    fill: "#ccc"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 280.07289,
    y: 427.33346,
    width: 71.25528,
    height: 1.00009,
    transform: "translate(-5.81924 4.35579) rotate(-.78329)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 279.44411,
    y: 418.28467,
    width: 67.55678,
    height: 1.00003,
    transform: "translate(-3.2621 2.45976) rotate(-.44761)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 278.87388,
    y: 409.63322,
    width: 64.63181,
    height: 1.00019,
    transform: "translate(-7.94955 6.15497) rotate(-1.11892)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 279.42757,
    y: 401.06322,
    width: 62.08987,
    height: 1.00055,
    transform: "translate(-13.15482 10.52415) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 278.86029,
    y: 393.09492,
    width: 59.65899,
    height: 1.00062,
    transform: "translate(-13.6382 11.08868) rotate(-2.01348)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 276.42856,
    y: 385.01857,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 275.06158,
    y: 378.33201,
    width: 56.44001,
    height: 1.00007,
    transform: "translate(-4.41831 3.57985) rotate(-.6714)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 273.79863,
    y: 371.91478,
    width: 54.71591,
    height: 1.00055,
    transform: "translate(-12.19267 10.19895) rotate(-1.9017)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 272.49522,
    y: 364.51849,
    width: 54.00926,
    height: 1.00015,
    transform: "translate(-6.36909 5.32021) rotate(-1.00705)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 270.78066,
    y: 357.92555,
    width: 51.73135,
    height: 1.00049,
    transform: "translate(-11.0506 9.44056) rotate(-1.78991)",
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 269.24863,
    y: 351.26855,
    width: 51.25244,
    height: 1.00005,
    transform: "translate(-3.42102 2.89627) rotate(-.55951)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M265.49979,330.42638v-67.81543c0-3.91113,3.18164-7.09277,7.09277-7.09277h32.81543c3.91016,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18164,7.0918-7.0918,7.0918h-32.81543c-3.91113,0-7.09277-3.18164-7.09277-7.0918Z",
    fill: "#6c63ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M189.0574,429.5172l-58.08984-3.7002-.46777-.03027v-44.95703c0-5.68555,4.62598-10.31152,10.31152-10.31152h57.37793c5.68555,0,10.31055,4.62598,10.31055,10.31152v48.68848h-.5l-18.94238-.00098Z",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M269.49979,207.42589v-51.81543c0-3.91064,3.18164-7.09229,7.09277-7.09229h10.81543c3.91016,0,7.0918,3.18164,7.0918,7.09229v51.81543c0,3.91064-3.18164,7.09229-7.0918,7.09229h-10.81543c-3.91113,0-7.09277-3.18164-7.09277-7.09229Z",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5,434.51826l-3-44-9-42-2.5-11.5h-.00001c-5.13733-3.49339-12.05536,.39254-11.74512,6.59734l.24513,4.90266,9,42,3,44",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.50272,423.51826l3.40229-63.28253s111.595-23.13555,111.595-89.82036S30.13744,195.56506,11.7651,226.18564c-.18372,.30621-.36632,.61236-.54781,.91842-22.69259,38.27041-9.88063,87.95544,28.7344,110.0565,13.20425,7.55736,28.94762,14.02434,47.34416,17.63151l-1.29586,67.22619",
    fill: "#ccc"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 479.06677,
    y: -7.35315,
    width: 2.00025,
    height: 911.77504,
    transform: "translate(1.52699 898.69753) rotate(-86.30501)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTown);
export default __webpack_public_path__ + "static/media/small_town.16712da1f5a76e605d5eb4bbe4a85064.svg";
export { ForwardRef as ReactComponent };